<template>
  <component
    v-for="(component, i) in components"
    :is="getComponentClass(component)"
    :key="createComponentKey(i)"
    :properties="component.properties"
    :pageData="pageData">
  </component>
</template>

<script>
// Needs globally registered Components ie. the component Repo.
import ComponentRepo from "../../services/ComponentRepo";

export default {
  name: "ComponentRender",
  props: ["components", "pageData"],
  methods: {
    getComponentClass(component) {
      return ComponentRepo.has(component.type)
        ? component.type
        : "NullComponent";
    },
    createComponentKey(index) {
      return `component-${index}`;
    },
  },
};
</script>